import { createSlice } from '@reduxjs/toolkit';

/* const initialState = {
    firstName: "susu",
    lastName: "susu",
    countryCode: "Afghanistan",
    mobileNum: "2222222222",
    email: "susura@grensesnitt.com"
};  */

const initialState = {};

const secConSlice = createSlice({
    name: "secondaryContract",
    initialState,
    reducers: {
        secondContractAdded(state, action) {         
            return {
				...state,
				firstName: action.payload.firstName,
                lastName: action.payload.lastName,
                countryCode: action.payload.countryCode,
                mobileNum: action.payload.mobileNum,
                email: action.payload.email,
			};
        }
    }
});

export const secondContractSelector = (state) => state.secContract;

export const { secondContractAdded} = secConSlice.actions
export default secConSlice.reducer
